import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ConfiguracaoEmpresaPage } from '@/features/configuracao/page/ConfiguracaoEmpresaPage';

const negocio = z.literal('negocio');
const meusUsuarios = z.literal('meus-usuarios');
const financeiro = z.literal('financeiro');
const estoque = z.literal('estoque');
const cadastros = z.literal('cadastros');
const vendas = z.literal('vendas');
const notificacoes = z.literal('notificacoes');
const arquivos = z.literal('arquivos');
const logs = z.literal('logs');

const SearchSchema = z.union([
    // Negócio
    z.object({
        tab1: negocio,
        tab2: z.literal('dados-negocio'),
    }),
    z.object({
        tab1: negocio,
        tab2: z.literal('certificado-digital'),
    }),
    z.object({
        tab1: negocio,
        tab2: z.literal('configuracao-fiscal'),
    }),
    z.object({
        tab1: negocio,
        tab2: z.literal('dados-contador'),
        tab3: z.enum(['cadastro', 'compartilhar']),
    }),
    z.object({
        tab1: negocio,
        tab2: z.literal('webhook'),
    }),
    z.object({
        tab1: negocio,
        tab2: z.literal('links-negocio'),
        tab3: z.enum(['site-divulgacao', 'catalogo-digital', 'consulta-clientes']),
    }),
    z.object({
        tab1: negocio,
        tab2: z.literal('meus-aplicativos'),
    }),

    // Meus usuários
    z.object({
        tab1: meusUsuarios,
        tab2: z.literal('gerenciamento'),
    }),
    z.object({
        tab1: meusUsuarios,
        tab2: z.literal('permissao-perfil'),
    }),

    // Financeiro
    z.object({
        tab1: financeiro,
        tab2: z.literal('conta-fintech'),
        tab3: z.enum(['info-conta', 'socio', 'documentacao', 'saque', 'personalizacao', 'taxas']),
    }),
    z.object({
        tab1: financeiro,
        tab2: z.literal('juros-multa'),
    }),
    z.object({
        tab1: financeiro,
        tab2: z.literal('parametros'),
    }),

    // Estoque
    z.object({
        tab1: estoque,
        tab2: z.literal('parametros'),
    }),

    // Cadastros
    z.object({
        tab1: cadastros,
        tab2: z.literal('padroes-preenchimento'),
    }),
    z.object({
        tab1: cadastros,
        tab2: z.literal('pessoas'),
    }),

    // Vendas
    z.object({
        tab1: vendas,
        tab2: z.literal('parametros'),
    }),
    z.object({
        tab1: vendas,
        tab2: z.literal('logistica'),
    }),
    z.object({
        tab1: vendas,
        tab2: z.literal('impressao'),
    }),
    z.object({
        tab1: vendas,
        tab2: z.literal('documento-fiscal'),
    }),

    // Notificações
    z.object({
        tab1: notificacoes,
        tab2: z.literal('parametros'),
    }),
    z.object({
        tab1: notificacoes,
        tab2: z.literal('whatsapp'),
    }),
    z.object({
        tab1: notificacoes,
        tab2: z.literal('extrato'),
    }),

    // Arquivos
    z.object({
        tab1: arquivos,
        tab2: z.literal('importacoes'),
    }),

    // Logs
    z.object({
        tab1: logs,
        tab2: z.undefined().optional(),
    }),
]);

export const Route = createFileRoute('/a/configuracao/empresa/')({
    component: Component,
    validateSearch: SearchSchema,
});

function Component() {
    const { tab1 } = Route.useSearch();

    return <ConfiguracaoEmpresaPage tab1={tab1} />;
}
